import { useEffect, useRef, useState } from "react";

// 默认轮询内容（用于 Scenario AI）
const DEFAULT_CONTENT = [
  "Any program allow for 1st time investor, rent free, DSCR ratio below 1?",
  "What loan program can I use to get a primary residence loan with 5% down and no mortgage insurance?",
  "What are the requirements for a warrantable condo?",
];

// 几秒变化一次
const TIME_OUT = 5 * 1000;

/**
 * @name useTextareaPlaceholder 输入框 placeholder 轮播
 * @param customContent 自定义内容数组，如果不提供则使用默认内容
 */
export default function useTextareaPlaceholder(customContent?: string[]) {
  const timer = useRef<NodeJS.Timer>();
  
  // 使用自定义内容或默认内容
  const content = customContent && customContent.length > 0 ? customContent : DEFAULT_CONTENT;

  const [placeholder, setPlaceholder] = useState<string>(
    content?.[0] || "",
  );

  useEffect(() => {
    // 如果只有一个内容，不需要轮播
    if (content.length <= 1) {
      setPlaceholder(content[0] || "");
      return;
    }

    let index = 1;
    timer.current = setInterval(() => {
      setPlaceholder(content[index]);
      if (index === content.length - 1) {
        index = 0;
      } else {
        index++;
      }
    }, TIME_OUT);
    
    return () => {
      clearInterval(timer.current);
    };
  }, [content]);

  return placeholder;
}
